import { IJobDescriptionDTO, JobDetailsTypes, JobResultTypes, JobType } from '../../api/jobs.dao';
import { JobDtoType } from '../jobs';

export type JobsSubscription = (jobs: JobDtoType[]) => void;
abstract class IJobsMonitor {
    abstract subscribe(subscription: JobsSubscription): void;
    abstract registerHandler<T extends JobDetailsTypes, K extends JobResultTypes | null = null>(
        type: JobType,
        handler: (jobDescription: IJobDescriptionDTO<T, K>) => void
    );
    abstract removeHandler<T extends JobDetailsTypes, K extends JobResultTypes | null = null>(
        type: JobType,
        handler: (jobDescription: IJobDescriptionDTO<T, K>) => void
    );
    abstract initialize();
    abstract cleanup();
    abstract getJobsByTypeFromCache<T extends JobDetailsTypes, K extends JobResultTypes | null = null>(
        type: JobType
    ): IJobDescriptionDTO<T, K>[];
    abstract cacheExists(): boolean;
}

export { IJobsMonitor };
